export default __webpack_public_path__ + "static/media/80-min.070e8f40.jpg";